import * as React from 'react';
import { FINISH_DATES } from '../../../../constants/filters';
import { formatQuarterDate } from '../../../../utils/dropdown';
import { Select } from '../../../Select';

interface IFinishDateProps {
  value: string | null | undefined;
  onChange(value: string): void;
}

export const FinishDate: React.VFC<IFinishDateProps> = ({ value, onChange }) => {
  return (
    <Select
      allowEmpty={false}
      placeholder="Любой срок сдачи"
      options={FINISH_DATES}
      value={value ?? ''}
      text={formatQuarterDate(value)}
      onChange={onChange}
      buttonParams={{ label: 'Срок сдачи' }}
    />
  );
};
